import { notification } from "antd";
import { BgCardModelType, GuaranteeController } from "./GuaranteeController";

export const getGuaranteePurchase = async (number: string) => {
  try {
    const { data } = await GuaranteeController.searchPurchase(number);
    return data[0] || [];
  } catch (error) {
    throw error;
  }
};

export const saveBgCard = async (model: BgCardModelType, orderId: string) => {
  try {
    await GuaranteeController.saveBgCard(model, orderId);
  } catch (error) {
    throw error;
  }
};

export const getBgCard = async (orderId: string) => {
  try {
    const { data } = await GuaranteeController.getBgCard(orderId);
    return data.components;
  } catch (error) {
    notification.error({
      message: "Что-то пошло не так...",
      description: "Попробуйте ещё раз позже",
    });
    throw error;
  }
};
